import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import { AdminGuardService } from '../../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck, ɵConsole } from '@angular/core';


import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";

import { AuthService } from '../../../servicios/auth.service';
import { UserGuardService } from '../../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../../servicios/guards/multi-user.service';

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { environment } from "environments/environment";
import { Router } from '@angular/router';
import { getTreeMissingMatchingNodeDefError } from '@angular/cdk/tree';

export interface PeriodicElement {
  IDPAGO:string;
  SUMA:string;
  FORMAPAGO:string;
  FECHAPAGO: string;
  DETALLE: string;
  IMPORTE: string;
  NROOPERA: string;
  CODBANCO: string;
  TIPOPAGO: string;
  SECCIONAL: string;
}
var ELEMENT_DATA: PeriodicElement[] = [];


@Component({
  selector: 'app-verop',
  templateUrl: './verop.component.html',
  styleUrls: ['./verop.component.css']
})
export class VeropComponent implements OnInit {
  @ViewChild('TABLE') table: ElementRef;

  displayedColumns: string[] = ['select','IDPAGO','FORMAPAGO','FECHAPAGO','DETALLE', 'SUMA','FONDO','TOTAL',/*'NROOPERA', 'CODBANCO',*/'TIPOPAGO','SECCIONAL'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  selection = new SelectionModel<PeriodicElement>(true, []);
 
  constructor(private http: HttpClient,public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.cargaGrid()
  }
  loading = true;
  cargaGrid(){
    //http://localhost:1337/api/getpago/getall?tipo=TODOS
    this.http.get(`${environment.backendUrl}/api/getpago/getall?tipo=TODOS`)
    .subscribe((data: any[]) => {
    this.dataSource.data = data; 
    console.log(this.dataSource.data);
    this.loading=false; 
  });
  console.log("grid cargado..");
    
  }

  dataSourcePago;
  loading2 = false;
  cuenta;
  nroope;
  det;
  detPa;
  getDatosPago(idpag){
    this.loading2 = true;
    //http://localhost:1337/api/getpago/getdatospago?codpag=01
    this.http.get(`${environment.backendUrl}/api/getpago/getdatospago?codpag=${idpag}`)
    .subscribe((data: any[]) => {
    this.dataSourcePago = data; 
    this.cuenta = this.dataSourcePago[0]["CODBANCO"];
    this.nroope = this.dataSourcePago[0]["NROOPERA"];
    this.det = this.dataSourcePago[0]["DETALLE"];
    this.detPa = this.dataSourcePago[0]["DETPADRE"];
    console.log(this.dataSourcePago);
    this.loading2=false; 
  });
  console.log("datos de pago cargados..");
  }

  reimprimir(){
    localStorage.setItem('codpag_edit',this.codi_pago_edit);
    console.log("REIMPRIMIR ORDEN " + this.codi_pago_edit);
    document.getElementById("botonImprime").click();
  }

  codi_pago_edit;
  selectRow(row) {
    this.codi_pago_edit=row;
    console.log(this.codi_pago_edit);
    this.getDatosPago(this.codi_pago_edit);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();  
    }
  }

  //Si el número de elementos seleccionados coincide con el número total de filas..
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  //Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }
  

}
